import { defineMessages } from 'react-intl';

const messages = defineMessages({
    cancel: {
        id: 'ConfirmDialog.cancel',
        defaultMessage: 'Cancel',
    },
});

export default messages;
